export default __webpack_public_path__ + "static/media/Mansa.6295fc86.jpg";